import React, { ReactNode } from "react";
import { ReactComponent as ErodeLogoBlack } from "../../assets/images/erode-logo-black.svg";

interface OnboardingLayoutProps {
  children: ReactNode;
  showProgress?: boolean;
  progressValue?: number; // 0-1
  showLogo?: boolean; // Option to hide logo for specific pages
  hasExistingPersonas?: boolean;
  onExit?: () => void;
}

/** Shared layout container so every onboarding step uses the same centered card shell. */
 function OnboardingLayout({
  children,
  showProgress = false,
  progressValue = 0,
  showLogo = true,
  hasExistingPersonas = false,
  onExit,
}: OnboardingLayoutProps) {
  const progressPercent = Math.min(Math.max(progressValue, 0), 1) * 100;

  return (
    <div className="min-h-screen bg-[#f8f9fa] p-6 flex items-center justify-center">
      <div className="w-full max-w-[672px]">
        {showProgress && (
          <div className="h-1.5 rounded-full bg-[rgba(162,187,191,0.2)] overflow-hidden mb-8">
            <div
              className="h-full bg-eai-primary-500 transition-[width]"
              style={{ width: `${progressPercent}%` }}
            />
          </div>
        )}
        <div className="rounded-[20px] border border-eai-bg-lt2 bg-white shadow-sm">
          {showLogo && (
            <div className="flex justify-between items-start px-8 pt-8">
              <ErodeLogoBlack className="w-36 h-16" />
              {hasExistingPersonas && onExit && (
                <button
                  onClick={onExit}
                  className="text-gray-400 hover:text-gray-600 transition-colors mt-4"
                  aria-label="Exit onboarding"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              )}
            </div>
          )}
          {children}
        </div>
      </div>
    </div>
  );
}

export default OnboardingLayout;
